import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/helpers/humanTime';
function historyText(event, viewedUser) {
  const actor = event.actor();
  const other = event.otherUser();
  if (!other) return '?';
  const isSelf = actor && viewedUser && actor.id() === viewedUser.id();
  const key = `forumaker-friendship.forum.history.${event.action()}_${isSelf ? 'self' : 'other'}`;

  // Raw User model under `user` — Translator.preprocessParameters() special-cases
  // that exact key and derives a `{username}` placeholder from it internally
  // (see AddFriendConfirmModal's identical comment for the full explanation).
  return app.translator.trans(key, {
    user: other
  });
}
export default class HistoryModal extends Modal {
  loading = true;
  loadingMore = false;
  events = [];
  total = 0;
  hasMore = false;
  className() {
    return 'FriendshipHistoryModal Modal--medium';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-history"
    }), " ", app.translator.trans('forumaker-friendship.forum.history_modal.title'));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.load();
  }
  async load(loadMore) {
    if (loadMore === void 0) {
      loadMore = false;
    }
    if (loadMore) {
      this.loadingMore = true;
    } else {
      this.loading = true;
      this.events = [];
    }
    m.redraw();
    try {
      const results = await app.store.find('friendship-events', {
        filter: {
          user: this.attrs.user.id()
        },
        include: 'otherUser,actor',
        page: {
          offset: loadMore ? this.events.length : 0,
          limit: 20
        }
      });
      const newEvents = results;
      this.events = loadMore ? [...this.events, ...newEvents] : newEvents;
      const meta = results.payload?.meta;
      this.total = meta?.page?.total ?? meta?.total ?? this.events.length;
      this.hasMore = this.events.length < this.total;
    } finally {
      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    }
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "Modal-body"
    }, this.events.length === 0 ? m("p", {
      className: "FriendshipHistoryModal-empty"
    }, app.translator.trans('forumaker-friendship.forum.history_modal.empty')) : m("ul", {
      className: "FriendshipHistoryModal-list"
    }, this.events.map(event => {
      const other = event.otherUser();
      return m("li", {
        className: "FriendshipHistoryModal-item",
        key: event.id()
      }, other && m(Avatar, {
        user: other
      }), m("div", {
        className: "FriendshipHistoryModal-itemContent"
      }, m("span", {
        className: "FriendshipHistoryModal-text"
      }, historyText(event, this.attrs.user)), m("span", {
        className: "FriendshipHistoryModal-date"
      }, humanTime(event.createdAt()))));
    })), this.hasMore && m("div", {
      className: "FriendshipHistoryModal-loadMore"
    }, m(Button, {
      className: "Button",
      loading: this.loadingMore,
      onclick: () => this.load(true)
    }, app.translator.trans('forumaker-friendship.forum.history_modal.load_more'))));
  }
}
flarum.reg.add('forumaker-friendship', 'forum/components/HistoryModal', HistoryModal);